import './index.scss'
import Head from '../head'
import OurStory from '../our-story'
import OurVision from '../our-vision'
import OurJourney from '../our-journey'
import OurValues from '../our-values'
import OurInvesters from '../our-investors'
import LeaderShip from '../leadership'
import OurTeam from '../our-team'
import TeamView from '../team-view'
import Mentor from '../mentor'
import Card from '../../landing-page/card'
import Mohan from '../../../assets/images/mohan.png'
import Visakh from '../../../assets/images/visakh.png'
import Navin from '../../../assets/images/navin.png'
import Winstin from '../../../assets/images/winstin.png'
import Sabareesh from '../../../assets/images/sabareesh.png'
import Nithin from '../../../assets/images/nithin.png'
import Guhan from '../../../assets/images/guhan.png'
import Vikram from '../../../assets/images/vikram.png'
import Gokulnathan from '../../../assets/images/gokulnathan.png'
import Yuvaraj from '../../../assets/images/yuvaraj.png'
import Kishore from '../../../assets/images/kishore.png'
import Gowtam from '../../../assets/images/gowtam.png'
import Surya from '../../../assets/images/surya.png'
import Bala from '../../../assets/images/bala.png'
import Abi from '../../../assets/images/abi.png'
import Gokul from '../../../assets/images/gokul.png'
import Pradeepa from '../../../assets/images/pradeepa.png'
import Chitra from '../../../assets/images/chitra.png'
import { useState } from 'react'
import { Helmet } from 'react-helmet-async'
import {motion} from "framer-motion"

const data = [
    {id:'emp1', img:Navin, name:"Navin", role:"Sr. Software Engineer", show:false, exp:"3+ Yrs", profile:""},
    {id:'emp2', img:Winstin, name:"Sebawinsten", role:"Software Engineer", show:false, exp:"2+ Yrs", profile:""},
    {id:'emp18', img:Chitra, name:"Chitra", role:"Facility Chief", show:false, exp:"1+ Yrs", profile:""},
    {id:'emp3', img:Sabareesh, name:"Sabareesh", role:"Software Engineer", show:false, exp:"1+ Yrs", profile:""},
    {id:'emp4', img:Nithin, name:"Nithiya kingston", role:"Software Engineer", show:false, exp:"1+ Yrs", profile:""},
    {id:'emp5', img:Guhan, name:"Guhan", role:"Software Engineer", show:false, exp:"1+ Yrs", profile:""},
    {id:'emp6', img:Vikram, name:"Vikram Atreya", role:"Software Engineer", show:false, exp:"1+ Yrs", profile:""},
    {id:'emp7', img:Gokulnathan, name:"Gokulnathan", role:"Software Engineer", show:false, exp:"1+ Yrs", profile:""},
    {id:'emp8', img:Mohan, name:"Mohan Pirasath", role:"Software Engineer", show:false, exp:"1+ Yrs", profile:""},
    {id:'emp9', img:Yuvaraj, name:"Yuvaraj", role:"UI/UX Designer", show:false, exp:"1+ Yrs", profile:""},
    {id:'emp10', img:Kishore, name:"Kishorekumar", role:"Software Engineer", show:false, exp:"1+ Yrs", profile:""},
    {id:'emp11', img:Gowtam, name:"Rajagowtham", role:"Software Engineer", show:false, exp:"1+ Yrs", profile:""},
    {id:'emp12', img:Surya, name:"Jayasurya", role:"Software Engineer", show:false, exp:"1+ Yrs", profile:""},
    {id:'emp13', img:Bala, name:"Balasubramanian", role:"Software Engineer", show:false, exp:"1+ Yrs", profile:""},
    {id:'emp14', img:Abi, name:"Abisheik Vijayarangan", role:"Software Engineer", show:false, exp:"<1 Yrs", profile:""},
    {id:'emp15', img:Gokul, name:"Gokul", role:"Software Engineer", show:false, exp:"<1 Yrs", profile:""},
    {id:'emp16', img:Pradeepa, name:"Pradeepa", role:"Business Development", show:false, exp:"<1 Yrs", profile:""},
    {id:'emp17', img:Visakh, name:"Visakh", role:"QA Engineer - Trainee", show:false, exp:"<1 Yrs", profile:""},
]

const About = () => {

    const [teamList, setTeamList] = useState(data)

    const toggleShow = (id:string) => {
        setTeamList(prevList => prevList.map(each => {
            if(id === each.id){
                return {...each, show:!each.show}
            }
            return each
        }))
    }

    return(
        <>
            <Helmet>
                <title>About-Us Page | Walkzero</title>
            </Helmet>
            <Head />
            <div className='d-flex flex-column align-self-center about-cont'>
                <OurStory />
                <OurVision />
            </div>
            <OurJourney />
            <OurValues />
            <OurInvesters />
            <div className='d-flex flex-column bg-col-mixed-white-blue position-relative p-b-80'>
                <LeaderShip />
                <div className='meet align-self-center'>
                    <p className="col-quaternary font-weight-5 text-12 mb-1 text-uppercase">Driven by Diversity, United by Vision</p>
                    <h1 className="col-container-font h2-size mb-0">Meet Our <span className='col-secondary'>Team</span></h1>
                </div>
                <div className='d-flex flex-row justify-content-center team-members align-self-center m-b-40'>
                {teamList.map((each, index) => {
                        return <div key={index} className='d-flex flex-column align-items-center'>
                                    <motion.div onMouseEnter={()=>toggleShow(each.id)} onMouseLeave={() => toggleShow(each.id)} className='emp-img d-flex flex-column justify-content-end align-items-center z-index-1' style={{backgroundImage:`url(${each.img})`}}>
                                        <motion.div initial={false}  animate={{y:each.show?0:50, opacity:each.show?1:0, transition:{duration:0.5}}} className='d-flex flex-column justify-content-start  align-items-center bg-col-light-primary-transparent w-100 emp-detail-height'>
                                            <p className='font-1 col-white font-weight-6 m-b-0 text-center emp-text'>{each.name}</p>
                                            <p className='font-1 col-secondary font-weight-6 m-t-0 m-b-0 text-center emp-text'>{each.role}</p>
                                            <a className='linkedin-btn'>in</a>
                                        </motion.div>
                                    </motion.div>
                                    <div className='bg-col-new-sky-blue-clr d-flex flex-row justify-content-center align-items-center z-index-5 exp-btn'>{each.exp}</div>
                                </div>
                    })}
                </div>
                <OurTeam />
                <div className="custom-shape-divider-top-1713956975">
                    <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
                        <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" className="shape-fill"></path>
                    </svg>
                </div>
                <div className="custom-shape-divider-bottom-1713957171">
                    <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
                        <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" className="shape-fill"></path>
                    </svg>
                </div>
            </div>
            <TeamView />
            <Mentor />
            <Card />
        </>
    )
}

export default About